export function buildQueryString(params: any, prefix = ""): string {
    const query = Object.keys(params)
      .map((key) => {
        const value = params[key];
        const prefixedKey = prefix ? `${prefix}[${key}]` : key;
  
        if (typeof value === "object" && value !== null) {
          return buildQueryString(value, prefixedKey);
        } else {
          return `${encodeURIComponent(prefixedKey)}=${encodeURIComponent(
            String(value)
          )}`;
        }
      })
      .join("&");
  
    return query;
  }